module.exports = __webpack_public_path__ + "static/TWAUS-rebrand-banner-tablet-4b6ad68278e05d0edf8463a5a8e5e180.png";